// extracted by mini-css-extract-plugin
export default {"registration":"profileandregform-module_registration_pBmub3Wp","legend-section":"profileandregform-module_legend-section_jlQgdqmq"};